export const isDummyOptionSymbol = (symbol: string) => {
  const optionMatch = symbol.match(/^([A-Z]+)(\d{8})([CP])(\d+(?:\.\d+)?)$/);
  return optionMatch ? true : false;
};
